<div class="d-inline-block">
    <button class="btn btn-outline-light text-dark border"
            (click)="dropdownMenu.toggle($event)">
        {{ 'hub.activities.sort-or-filter' | translate }}
        <fa-icon [icon]="['fas', 'caret-down']"></fa-icon>
    </button>

    <p-overlayPanel #dropdownMenu>
        <div style="min-width: 200px;">
            <ul class="nav flex-column my-2">
                <li class="nav-item px-3 pl-0 dropdown-item">
                    <a class="p-0 dropdown-item" href="javascript:void(0)" (click)="setDirection('desc')">
                        <div class="d-flex">
                            <div style="width: 30px;">
                                <fa-icon *ngIf="direction === 'desc'" [icon]="['far', 'check']"></fa-icon>
                            </div>
                            {{ 'hub.activities.sort-options.newest-first' | translate }}
                        </div>
                    </a>
                </li>

                <li class="nav-item px-3 pl-0 dropdown-item">
                    <a class="p-0 dropdown-item" href="javascript:void(0)" (click)="setDirection('asc')">
                        <div class="d-flex">
                            <div style="width: 30px;">
                                <fa-icon *ngIf="direction === 'asc'" [icon]="['far', 'check']"></fa-icon>
                            </div>
                            {{ 'hub.activities.sort-options.oldest-first' | translate }}
                        </div>
                    </a>
                </li>
            </ul>

            <div class="dropdown-divider"></div>

            <ul class="nav flex-column my-2">
                <li class="nav-item px-3 pl-0 dropdown-item">
                    <a class="p-0 dropdown-item" href="javascript:void(0)" (click)="setFilter('all')">
                        <div class="d-flex">
                            <div style="width: 30px;">
                                <fa-icon *ngIf="filter === 'all'" [icon]="['far', 'check']"></fa-icon>
                            </div>
                            {{ 'hub.activities.show-options.all-activity' | translate }}
                        </div>
                    </a>
                </li>
                <li class="nav-item px-3 pl-0 dropdown-item">
                    <a class="p-0 dropdown-item" href="javascript:void(0)" (click)="setFilter('comment')">
                        <div class="d-flex">
                            <div style="width: 30px;">
                                <fa-icon *ngIf="filter === 'comment'" [icon]="['far', 'check']"></fa-icon>
                            </div>
                            {{ 'hub.activities.show-options.comments-only' | translate }}
                        </div>
                    </a>
                </li>
                <li class="nav-item px-3 pl-0 dropdown-item">
                    <a class="p-0 dropdown-item" href="javascript:void(0)" (click)="setFilter('event')">
                        <div class="d-flex">
                            <div style="width: 30px;">
                                <fa-icon *ngIf="filter === 'event'" [icon]="['far', 'check']"></fa-icon>
                            </div>
                            {{ 'hub.activities.show-options.events-only' | translate }}
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </p-overlayPanel>
</div>
